import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

import { NzConfigService } from 'ng-zorro-antd/core/config';

import { CoreAlertComponent } from '@shared/components/core-alert/core-alert.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, CoreAlertComponent],
  template: `<router-outlet></router-outlet>
              <app-core-alert></app-core-alert>`,
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'corecredit-personas-front';

  constructor(
    private readonly nzConfigService: NzConfigService
  ) {
    this.nzConfigService.set('dropDown', { nzBackdrop: true });
  }
}
